import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/Permissions.module.css';
import bellIcon from '../static/img/icons/bell.png';
import locationIcon from '../static/img/icons/location.png';
import micIcon from '../static/img/icons/mic.png';
import cameraIcon from '../static/img/icons/camera.png';
import galleryIcon from '../static/img/icons/gallery.png';
import autoIcon from '../static/img/icons/auto.png';
const ICONS = {
    notifications: bellIcon,
    location: locationIcon,
    microphone: micIcon,
    camera: cameraIcon,
    gallery: galleryIcon,
    autoDetect: autoIcon,
};

const Permissions = () => {
    const navigate = useNavigate();

    const [permissions, setPermissions] = useState({
        notifications: true,
        location: false,
        microphone: false,
        camera: true,
        gallery: true,
        autoDetect: true,
    });

    const toggle = (key) => {
        setPermissions(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const items = [
        {
            key: "notifications",
            title: "Notifications",
            desc: "Tournament alerts, daily rewards, results",
            color: "yellow"
        },
        {
            key: "location",
            title: "Location",
            desc: "Region-specific tournaments",
            color: "red"
        },
        {
            key: "microphone",
            title: "Microphone",
            desc: "In-game voice chat",
            color: "blue"
        },
        {
            key: "camera",
            title: "Camera",
            desc: "Submit screenshots, take avatar photo",
            color: "green"
        },
        {
            key: "gallery",
            title: "Photo Library",
            desc: "Upload screenshots from gallery",
            color: "purple"
        },
        {
            key: "autoDetect",
            title: "Auto-detect screenshots",
            desc: "Match submission without manual upload",
            color: "orange"
        }
    ];

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <div className={styles.iconBtn} onClick={() => navigate(-1)}>‹</div>
                <div className={styles.title}>PERMISSIONS</div>
                <div className={styles.iconBtn}>≡</div>
            </div>

            {/* INFO */}
            <div className={styles.infoBox}>
                Control which device features ESL can access. You can revoke any permission at any time.
            </div>

            {/* LIST */}
            <div className={styles.list}>
                {items.map(item => {
                    const isActive = permissions[item.key];

                    return (
                        <div key={item.key} className={styles.card}>

                            <div className={styles.left}>
                                <div className={`${styles.iconBox} ${styles[item.color]}`}>
                                    <img src={ICONS[item.key]} alt="" />
                                </div>

                                <div>
                                    <div className={styles.titleText}>{item.title}</div>
                                    <div className={styles.desc}>{item.desc}</div>
                                </div>
                            </div>

                            {/* TOGGLE */}
                            <div
                                className={`
                                    ${styles.toggle}
                                    ${isActive ? styles[`toggle_${item.color}`] : ''}
                                `}
                                onClick={() => toggle(item.key)}
                            >
                                <div className={styles.knob}></div>
                            </div>

                        </div>
                    );
                })}
            </div>

        </div>
    );
};

export default Permissions;